/**
 * 医嘱模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取医嘱列表
export const adviceList = (params) => {
  return req.get('/hosp/advice/template/list', params);
}

// 新增医嘱
export const adviceAdd = (params) => {
  return req.post('/hosp/advice/template', params);
}

// 修改医嘱信息
export const adviceEdit = (params) => {
  return req.put('/hosp/advice/template', params);
}

// 删除医嘱信息
export const adviceDelete = (doctorAdviceTemplateIds) => {
  return req.delete(`/hosp/advice/template/${doctorAdviceTemplateIds}`);
}